import {
  Component,
  ElementRef,
  inject,
  Input,
  input,
} from '@angular/core';
import { PayeeRippleDirective } from '../../payee-ripple/payee-ripple.directive';

@Component({
  selector: 'button[payee-copy-button]',
  templateUrl: './payee-copy-button.component.html',
  styleUrls: ['./payee-copy-button.component.scss'],
  imports: [PayeeRippleDirective],
  host: {
    '[attr.size]': 'size()',
  },
})
export class PayeeCopyButtonComponent {
  private ref = inject<ElementRef<HTMLButtonElement>>(ElementRef);

  @Input() input?: HTMLInputElement | HTMLTextAreaElement;
  @Input() disableRipple = false;
  @Input() color = 'black';
  readonly size = input('normal');

  get element() {
    return this.ref.nativeElement;
  }

  constructor() {
    this.ref.nativeElement.addEventListener('click', () =>
      this.copyTextToClipboard(),
    );
  }

  copyTextToClipboard() {
    if (!this.input) {
      return;
    }

    this.input.select();
    this.input.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(this.input.value);
  }
}
